import React from 'react';
import '../App.css';
import $ from 'jquery';
import config from '.././config';
import { Redirect } from 'react-router';
import LoginForm from '../LoginForm';
import { Table, Input, Button, Icon, Badge, Modal, Popconfirm, notification, Select, Form, Col, Row } from 'antd';
import { JSONToCSVConvertor } from '../Helpers/ExportToExcel';
import { Base64ToArrayBuffer } from '../Helpers/PrintToPDF';

/*
 Description:
 Allows Admin to view students who have taken classes.

 Search by: 
 - last name OR techID OR Employer 

 From the UI go to the Admin section then the Search Student History link.
*/

//Form styling
const Option = Select.Option;
const FormItem = Form.Item;
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
    }
};

class SearchStudentHistory extends React.Component {

    constructor(props) {
        super(props);
        this.state.employer = {
            Id: -1, CompanyName: '', Address: '', State: 'ND',
            City: '', ZipCode: '', PhoneNumber: '', Email: ''
        };
        this.employerDisplayList = [];
    }
    state = {

        //Is the admin logged in
        login: true,

        //Data that is displayed in the results table.
        classData: [],

        //Arrays that store dropdown values
        lastNameArr: [],
        techIdArr: [],
        employerArr: [],

        sortedInfo: null
    };
    
    //Default values for searchable dropdowns
    lastNameSearch = 'All';
    techIdSearch = 'All';
    employerSearch = 'All';

    render() {
        const { getFieldDecorator } = this.props.form;
        let { sortedInfo } = this.state;
        sortedInfo = sortedInfo || {};

        //Shows what the table will be returning
        const Columns = [

            {
                title: 'Tech ID',
                dataIndex: 'TechID',

                sorter: (a, b) => a.TechID - b.TechID,
                sortOrder: sortedInfo.columnKey === 'TechID' && sortedInfo.order
            },

            {
                title: 'First Name',
                dataIndex: 'FirstName',
                key: 'FirstName'
            },

            {
                title: 'Middle Initial',
                dataIndex: 'MiddleInitial'
            },

            {
                title: 'Last Name',
                dataIndex: 'LastName'
            },

            {
                title: 'Employer',
                dataIndex: 'EmployerName'
            },

            {
                title: 'Class Name',
                dataIndex: 'ClassName'
            },

            {
                title: 'Attendance',
                dataIndex: 'AttendanceSelection'
            },

            {
                title: 'Class Start Date',
                dataIndex: 'ClassStartDate'
            }
        ];

        /*The UI*/
        return (
            <div>
                {/*comment when testing so developer won't be logged out everytime code is changed.*/}
                {this.state.login ?
                    <div>
                        <h1>Search Student History</h1>
                        <hr />

                        <div className="container">

                            <div style={{ width: 800 }} className="panel panel-default">

                                <div className="panel-heading">
                                    <h2>Search Criteria</h2>
                                </div>

                                <br />
                                <div id="hideLName">

                                    {/*Last name searchable dropdown*/}
                                    <FormItem
                                        {...formItemLayout}
                                        label="Last Name"
                                    >
                                        {getFieldDecorator('lastNameSearchDropdown')(
                                            <Select
                                                style={{ width: '40%' }}
                                                showSearch
                                                placeholder="All"
                                                optionFilterProp="children"
                                                onChange={this.handleLastNameChange}
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                <Option key={'All'}>All</Option>
                                                {this.state.lastNameArr.map(a => <Option key={a.LastName + "|" + a.Id}>{a.LastName}</Option>)}
                                            </Select>
                                        )}
                                    </FormItem>

                                </div>

                                <div id="hideTech">
                                    {/*Technician ID # searchable dropdown*/}
                                    <FormItem id="techIdSearchDropdown"
                                        {...formItemLayout}
                                        label="Technician ID #"
                                    >
                                        {getFieldDecorator('techIdSearchDropdown')(
                                            <Select
                                                style={{ width: '40%' }}
                                                showSearch
                                                placeholder="All"
                                                optionFilterProp="children"
                                                onChange={this.handleTechIdChange}
                                            >
                                                <Option key={'All'}>All</Option>
                                                {this.state.techIdArr.map(a => <Option key={a.TechID}>{a.TechID}</Option>)}
                                            </Select>
                                        )}
                                    </FormItem>

                                </div>

                                <div id="hideEmp">

                                    {/*Employer searchable dropdown*/}
                                    <FormItem
                                        {...formItemLayout}
                                        label="Search Employer"
                                    >
                                        {getFieldDecorator('searchEmployerDropdown')(

                                            <Select
                                                style={{ width: '90%' }}
                                                showSearch
                                                placeholder="All"
                                                optionFilterProp="children"
                                                onChange={this.handleEmployerChange}
                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                            >
                                                <Option key={'All'}>All</Option>
                                                {this.employerDisplayList}
                                            </Select>
                                        )}
                                    </FormItem>

                                </div>

                                {/*Search and Reset buttons*/}
                                <Row gutter={8}>

                                    <Col span={12}>
                                        <center>
                                            <button className="btn btn-default" onClick={this.SearchClassHistory} size="large">Search</button>&nbsp;
                                            <button className="btn btn-default" onClick={this.ResetClassHistory} size="large">Reset</button>
                                        </center>
                                    </Col>

                                </Row>

                                <br />
                            </div>
                        </div>
                        <br />
                        <br />

                        {/*Print button*/}
                        <Button type="primary" style={{ marginBottom: 10 }} onClick={this.printPDF}>Print</Button>
                        <Button type="primary" 
                            style={{
                                marginBottom: 10, marginLeft: 10, background: 'MediumSeaGreen',
                                borderColor: 'MediumSeaGreen'
                            }}
                            onClick={this.excelExport}> Export to Excel</Button>

                        {/*Display table*/}
                        <Table bordered columns={Columns}
                            dataSource={this.state.classData}
                            onChange={this.handleChangeSort}
                            scroll={{ x: 900 }}
                            size="small"
                            pagination={{ pageSize: 30, current: this.state.current, onChange:(page, pageSize)=>{this.setState({current:page})}}}
                        />
                        
                        {/*comment when testing*/}
                    </div>
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }

    //Fill all the dropdowns. 
    refresh() {

        this.fillLastNameDropdown();
        this.fillTechIdDropdown();
        this.fillEmployerDropdown();
    }

    /*Called when the print button is clicked.
    Sends the table results to an api that turns
    it into a pdf. Then opens a pdf window with
    options to view or download that table.*/
    printPDF = () => {

        $.ajax({
            type: 'POST',
            url: `${config.serverUrl}/api/View/printStudentHistory`,
            contentType: 'application/json',
            /*Had to use stringify here in order to send an array
            that may not exactly match what the backend is looking
            for.*/
            data: JSON.stringify(this.state.classData)
        })
            .done((result) => {

                var byteArray = Base64ToArrayBuffer(result);
                var blob = new Blob([byteArray], { type: "application/pdf;charset=utf-8" });
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, "StudentHistory.pdf");
                }
                else {
                    var downloadpdf = $('<a id="downloadpdf" download="StudentHistory.pdf" href="data:application/pdf;base64,' + result + '" >');
                    $('body').append(downloadpdf);
                    document.getElementById("downloadpdf").click();
                    $("#downloadpdf").remove();
                }
            })
            .fail((error) => {
                console.log('Error in printPDF');
            });
    }

    //Called when the export to excel button is clicked.
    //Calls a function that's been imported from a helper folder.
    //The results table is passed in and the name of the file.
    excelExport = () => {

        try {
            JSONToCSVConvertor(this.state.classData, "Student History", true, 'text/csv;encoding:utf-8');
        }
        catch(error){
            console.log("Error in excelExport");
        }
    }


    /*-----------------------------------Start of handling dropdown functions---------------------------------------*/

    /* 
    * These functions store the value of what the user selects in the dropdown.
    */

    handleLastNameChange = (value) => {

        var res = value.split("|");
        var lastname = res[0];
        this.lastNameSearch = lastname;

        $("#hideTech").hide();
        $("#hideEmp").hide();
    }

    handleTechIdChange = (value) => {

        this.techIdSearch = value;

        $("#hideLName").hide();
        $("#hideEmp").hide();
    }

    handleEmployerChange = (value) => {

        this.employerSearch = value;

        $("#hideLName").hide();
        $("#hideTech").hide();
    }

    /*-----------------------------------End of handling dropdown functions-----------------------------------------*/


    /*-----------------------------------Start of filling dropdown functions----------------------------------------*/

    /*
    * These functions fill the dropdowns. They make an ajax get server request that runs
    * a query. That result gets returned as data. The data is then filted to show whatever
    * the dropdown needs to show.
    */

    //Fill dropdown with last names.
    fillLastNameDropdown() {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getAllClassHistory`
        })
            .done((data) => {

                var seenNames = {};
                this.array = data;
                this.array = this.array.filter(function (currentObject) {
                    if (currentObject.LastName in seenNames) {
                        return false;
                    } else {
                        seenNames[currentObject.LastName] = true;
                        return true;
                    }
                });

                this.setState({
                    lastNameArr: this.array
                });
            })

            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('error in fillLastNameDropdown() ');
            });
    }

    //Fill dropdown with techIds.
    fillTechIdDropdown() {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getAllClassHistory`
        })
            .done((data) => {

                var seenTechId = {};
                this.array = data;
                this.array = this.array.filter(function (currentObject) {
                    if (currentObject.TechID in seenTechId) {
                        return false;
                    } else {
                        seenTechId[currentObject.TechID] = true;
                        return true;
                    }
                });

                this.setState({
                    techIdArr: this.array
                });
            })

            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('error in fillTechIdDropdown()');
            });
    }

    //Fill dropdown with employer names, cites, and states.
    fillEmployerDropdown() {

        this.employerDisplayList = [];
        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/employer/getAllEmployersWithClasses`
        })
            .done((data) => {
                for (let i = 0; i < data.length; i++) {
                    var optDis = data[i].CompanyName + ", " + data[i].City + " (" + data[i].State + ")";
                    this.employerDisplayList.push(
                        <Option key={data[i].Id}>{optDis}</Option>
                    );
                }

                // this.employerDisplayList.push(
                //     <Option key="Other">Other</Option>
                // );

                this.setState({
                    employerArr: data
                });

            })
            .fail((jqXhr) => {
                console.log('failed to get employer');
            });
    }

    /*----------------------------------End of filling dropdown functions-------------------------------------------*/

    // This function is checking which search criteria was selected and then
    // calls a function that performs that specific search.

    SearchClassHistory = () => {

        //If nothing is selected, show everything
        if (this.isLastNameSet() === false && this.isTechIdSet() === false && this.isEmployerSet() === false) {

            this.getAllClassHistory();
        }

        //If only a last name is entered, search by that.
        else if (this.isLastNameSet() === true && this.isTechIdSet() === false && this.isEmployerSet() === false) {

            this.searchByLastName();
        }

        //If only a techId is entered, search by that.
        else if (this.isTechIdSet() === true && this.isLastNameSet() === false && this.isEmployerSet() === false) {

            this.searchByTechId();
        }

        //If only a employer is selected, search by that.
        else if (this.isEmployerSet() === true && this.isTechIdSet() === false && this.isLastNameSet() === false) {

            this.searchByEmployer();
        }
    }

    /*-----------------------------------Start of boolean isSet functions--------------------------------------------*/
    /*
    * These functions check if the dropdown selection has changed. This could be due to the user typing in
    * a search criteria or selecting a value from the dropdown. The default value is 'All', so if it's not
    * that, then we know something was selected.
    */

    isLastNameSet() {

        if (this.lastNameSearch !== 'All') {
            return true;
        }
        else {
            return false;
        }
    }

    isTechIdSet() {

        if (this.techIdSearch !== 'All') {
            return true;
        }
        else {
            return false;
        }
    }

    isEmployerSet() {

        if (this.employerSearch !== 'All') {
            return true;
        }
        else {
            return false;
        }
    }

    /*-----------------------------------End of boolean isSet functions----------------------------------------------*/

    /*-----------------------------------Start of searching by criteria----------------------------------------------*/
    /*
    * These functions use an ajax get request that links to an api web controller. The controllers use
    * methods that contains sql queries. The result of the query comes back as data. That data gets put
    * into the classData[], which is used to populate the results table.
    */

    getAllClassHistory() {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getAllClassHistory`
        })
            .done((data) => {

                this.setState({
                    classData: data
                });
            })

            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('error in getAllClassHistory()');
            });
    }

    //Get the class history for student by their last name.
    searchByLastName() {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getAllClassHistory`
        })
            .done((data) => {

                let lastname = this.lastNameSearch;
                data = data.filter(function (item) {
                    if (item.LastName === lastname) {
                        return true;
                    }
                });

                this.setState({
                    classData: data
                });
            })

            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('error in  searchByLastName()');
            });
    }

    //Get the class history for student by their techId.
    searchByTechId() {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getAllClassHistory`
        })
            .done((data) => {

                let techId = parseInt(this.techIdSearch);
                data = data.filter(function (item) {
                    if (item.TechID === techId) {
                        return true;
                    }
                });

                this.setState({
                    classData: data
                });
            })

            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('error in searchByTechId()');
            });
    }

    //Get class history for students who work for a certain employer.
    searchByEmployer() {

        $.ajax({
            type: 'GET',
            url: `${config.serverUrl}/api/students/getStudentsByEmployer/`,

            //This is the parameter I am passing to getStudentsByEmployer.
            data: { empId: this.employerSearch }
        })
            .done((data) => {

                this.setState({
                    classData: data
                });
            })

            .fail((jqXHR, textStatus, errorThrown) => {
                console.log('error in searchByEmployer()');
            });
    }

    /*----------------------------------End of searching by criteria-------------------------------------------------*/

    //When the reset button is clicked
    ResetClassHistory = () => {

        //Reset all dropdown values to null
        this.props.form.setFieldsValue({
            ['lastNameSearchDropdown']: 'All',
            ['techIdSearchDropdown']: 'All',
            ['searchEmployerDropdown']: 'All'
        });

        //Set search boxes to default value of all
        this.lastNameSearch = 'All';
        this.techIdSearch = 'All';
        this.employerSearch = 'All';

        //Clear the table
        this.setState({
            classData: []
        });

        //Show dropdowns again
        $("#hideTech").show();
        $("#hideEmp").show();
        $('#hideLName').show();
    }

    onInputChange = (e) => {

        this.setState({ searchText: e.target.value });
    }

    handleChangeSort = (pagination, filters, sorter) => {

        this.setState({
            sortedInfo: sorter
        });
    }

    componentDidMount() {

        //Comment this method when testing.
        LoginForm.ValidateServerToken(
            //logout
            () => { this.setState({ login: false }); }, 
            //populate the dropdown fields
            () => { this.refresh(); }
        );
        //uncomment when testing
        //this.refresh();
    }
}

const WrappedAdvancedSearchForm = Form.create()(SearchStudentHistory);
export default WrappedAdvancedSearchForm;





// WEBPACK FOOTER //
// ./src/Admin/SearchStudentHistory.js